import axios from 'axios';
import classNames from 'classnames';
import { SERVER_URL } from 'Constants';
import { useState } from 'react';
import { catchErrorAsync } from 'Util/CatchErrorAsync';
import alertToast from 'Util/ToastifyUtils';
import ToggleSwitch from 'Views/Components/ToggleSwitch/ToggleSwitch';

async function modifyEnforceOnlinePaymentForOrganisation(
	organisationId: string, 
	enforcePayment: boolean
) {
	await axios.post(`${SERVER_URL}/api/payment/set-enforce-online-payment`, {
		organisationId: organisationId,
		enforceOnlinePayment: enforcePayment
	});
}

type Props = {
	initialEnforcePaymentValue: boolean;
	organisationId: string;
	isReadOnly: boolean;
};

export const EnforceOnlinePaymentField: React.FunctionComponent<Props> = ({
	initialEnforcePaymentValue,
	organisationId,
	isReadOnly
}) => {
	const [isEnforcePayment, setIsEnforcePayment] = useState(initialEnforcePaymentValue);
	const handleEnforcePaymentUpdate = async (enforcePayment: boolean) => {
		if (isReadOnly) return;
		setIsEnforcePayment(enforcePayment);
		const [error] = await catchErrorAsync(modifyEnforceOnlinePaymentForOrganisation(organisationId, enforcePayment));
		if (error) {
			alertToast(`Failed to ${enforcePayment ? "enable" : "disable"} enforce online payment`, "error");
			setIsEnforcePayment(initialEnforcePaymentValue);
			return;
		}

		alertToast(`Successfully ${enforcePayment ? "enabled" : "disabled"} enforce online payment`, "success");
	}

	return (
		<div className={classNames('billing-field', { "read-only": isReadOnly })}>
			<div className='billing-field__title'>
				<div className='header'>
					<h6>Upfront credit card payment for consumption costs required</h6>
					<p className="description">
						{/* eslint-disable-next-line max-len */}
						Your Organisation will be charged upfront (pay-as-you-go) via the default credit card for credit report consumption unless a business entity has a separate payment method configured. If disabled, charges will be invoiced monthly to the organisation.
					</p>
				</div>
				<div className='actions'>
					<ToggleSwitch 
						model={{ value: isEnforcePayment }} 
						modelProperty="value" 
						onAfterChecked={async (_, checked) => {
							setIsEnforcePayment(checked);
							await handleEnforcePaymentUpdate(checked);
						}}
						hideLabel
						isDisabled={isReadOnly}
					/>
				</div>
			</div>
		</div>
	)
}